import { Trans, useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { Reveal } from 'src/components/reveal';
import { StarSky } from 'src/components/star-sky';
import { NightLog } from 'src/components/night-log';
import { ButtonLink } from 'src/components/button-link';

export function HomeHero() {
  const { t } = useTranslation('home');

  return (
    <section className="hero">
      <StarSky />
      <div className="container">
        <div className="hero-grid">
          <div>
            <span className="eyebrow">{t('hero.eyebrow')}</span>
            <h1>
              <Trans
                ns="home"
                i18nKey="hero.title"
                components={{ accent: <span className="accent" /> }}
              />
            </h1>
            <p className="lead">{t('hero.lead')}</p>
            <div className="hero-actions">
              <ButtonLink
                withArrow
                variant="blue"
                to={paths.contact}
                label={t('hero.primaryAction')}
              />
              <ButtonLink
                variant="ghost"
                to={paths.servicesAnchor}
                label={t('hero.secondaryAction')}
              />
            </div>
            <p className="hero-note">{t('hero.note')}</p>
          </div>
          <Reveal>
            <NightLog lines={t('console.lines', { returnObjects: true })} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
